(function () {
  'use strict';

  /* @ngdoc object
   * @name messageAdmin
   * @description
   *
   */
  angular
    .module('greatCircleDistance', [
      'ui.router'
    ]);
}());
